import Link from 'next/link';
import { styled } from '@mui/material';

export const DescriptionLink = styled(Link)({
  color: 'inherit',
  textDecoration: 'underline',
});
